import React from 'react';
import { Link } from 'react-router-dom';
import { useScroll, useToggle } from '@hooks';

const Header: React.FC = () => {
  const { scrollY, scrollDirection } = useScroll();
  const [isNavOpen, toggleNav] = useToggle(false);

  const isHeaderActive = scrollY >= 50;
  const isHeaderHidden = scrollDirection === 'down' && scrollY >= 50;

  const handleNavToggle = () => {
    toggleNav();
    document.body.classList.toggle('nav-active');
  };

  const handleNavLinkClick = () => {
    if (isNavOpen) {
      handleNavToggle();
    }
  };

  return (
    <header
      className={`header ${isHeaderActive ? 'active' : ''} ${isHeaderHidden ? 'hide' : ''}`}
      data-header
    >
      <div className="container">
        <Link to="/" className="logo">
          <img
            src="/assets/images/logo.png"
            width="240"
            height="75"
            alt="Happy Valley Village - Home"
          />
        </Link>

        <nav className={`navbar ${isNavOpen ? 'active' : ''}`} data-navbar>
          <button
            className="close-btn"
            aria-label="close menu"
            onClick={handleNavToggle}
          >
            <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
          </button>

          <Link to="/" className="logo">
            <img
              src="/assets/images/logo.png"
              width="240"
              height="75"
              alt="Happy Valley Village - Home"
            />
          </Link>

          <ul className="navbar-list">
            <li className="navbar-item">
              <Link
                to="/#home"
                className="navbar-link hover-underline"
                onClick={handleNavLinkClick}
              >
                <div className="separator"></div>
                <span className="span">Home</span>
              </Link>
            </li>

            <li className="navbar-item">
              <a
                href="https://happy-valley-village.res-menu.com/menu"
                className="navbar-link hover-underline"
                onClick={handleNavLinkClick}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="separator"></div>
                <span className="span">Menus</span>
              </a>
            </li>

            <li className="navbar-item">
              <Link
                to="/#best-iron-stew-pot"
                className="navbar-link hover-underline"
                onClick={handleNavLinkClick}
              >
                <div className="separator"></div>
                <span className="span">About Us</span>
              </Link>
            </li>

            <li className="navbar-item">
              <Link
                to="/#authentic-northeastern-iron-pot-stews"
                className="navbar-link hover-underline"
                onClick={handleNavLinkClick}
              >
                <div className="separator"></div>
                <span className="span">Our Chefs</span>
              </Link>
            </li>

            <li className="navbar-item">
              <Link
                to="/review"
                className="navbar-link hover-underline"
                onClick={handleNavLinkClick}
              >
                <div className="separator"></div>
                <span className="span">Review</span>
              </Link>
            </li>

            <li className="navbar-item">
              <Link
                to="/contact"
                className="navbar-link hover-underline"
                onClick={handleNavLinkClick}
              >
                <div className="separator"></div>
                <span className="span">Contact</span>
              </Link>
            </li>
          </ul>

          <div className="text-center">
            <p className="headline-1 navbar-title">Visit Us</p>

            <address className="body-4">
              1655 S Azusa Ave Ste E <br />
              Hacienda Heights, CA 91745
            </address>

            <p className="body-4 navbar-text">Open: 11:30 AM - 2:30 PM, 5:00 PM - 10:00 PM</p>

            <a
              href="https://order.mealkeyway.com/customer/release/index?mid=4971444c6b4878337143434241416e6e6c6e63384f513d3d#/main"
              className="body-4 sidebar-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Order Online
            </a>

            <div className="separator"></div>

            <p className="contact-label">Booking Request</p>

            <a href="tel:+16263637268" className="body-1 contact-number hover-underline">
              +1 626-363-7268
            </a>
          </div>
        </nav>

        <a href="#" className="btn btn-secondary">
          <span className="text text-1">Find A Table</span>
          <span className="text text-2" aria-hidden="true">
            Find A Table
          </span>
        </a>

        <button
          className="nav-open-btn"
          aria-label="open menu"
          onClick={handleNavToggle}
        >
          <span className="line line-1"></span>
          <span className="line line-2"></span>
          <span className="line line-3"></span>
        </button>

        <div
          className={`overlay ${isNavOpen ? 'active' : ''}`}
          onClick={handleNavToggle}
          data-overlay
        ></div>
      </div>
    </header>
  );
};

export default Header;
